// extracted by mini-css-extract-plugin
export default {"meals":"AvailiableMeals_meals__Zyz6m","meals-appear":"AvailiableMeals_meals-appear__D8vME"};